import { Fragment, useContext } from "react";

import CustomButton from "../../General_Elements/CustomButton/CustomButton";

import SearchContext from "../../../store/search-context";

// component contains the action buttons for the Search page
const CartActions = (props) => {
  const searchCtx = useContext(SearchContext);

  return (
    <Fragment>
      <CustomButton onClick={props.onSearch} content={"SEARCH"} type={"searchButton"} width="45%" height="60%"/>
      <CustomButton onClick={searchCtx.clearSearch} content={"CLEAR"} type={"clearButton"} width="45%" height="60%"/>
    </Fragment>
  );
};

export default CartActions;
